import Config from './config';

export default class Interface {
  get duration() {
    return Config.rotate;
  }

  get rotationEnabled() {
    return true;
  }

  get allowEmpty() {
    return false;
  }

  markUnavailable() {
    return false;
  }

  async getMedia() {
    return Config.defaultMedia;
  }
}
